import React from 'react';
import Image from 'next/image';
import PropTypes from 'prop-types';
import { Button } from '@ui/button';
import WelcomeAppImage from '../../images/CheckoutConfirmation/WelcomeApp.png';
import {
  StyledAppImageContainer,
  StyledContent,
  StyledHeadline,
  StyledTitle,
  StyledWelcomeToThePackContainer,
  StyledBody,
} from './styles';

export const WelcomeToThePack = ({ accessToken }) => {
  return (
    <StyledWelcomeToThePackContainer>
      <StyledAppImageContainer>
        <Image
          src={WelcomeAppImage}
          alt="Welcome To The Pack Image"
          width={96}
          height={188}
        />
      </StyledAppImageContainer>
      <StyledContent>
        <StyledHeadline>WELCOME TO THE PACK</StyledHeadline>
        <StyledTitle>Log into your new Ollie account</StyledTitle>
        <StyledBody>
          You’re amongst furry friends! Find more screenings, explore extras,
          and more in our app.
        </StyledBody>
        <Button
          onClick={() =>
            window?.ReactNativeWebView?.postMessage(
              JSON.stringify({
                type: 'navigate',
                payload: { screen: 'Sign In', accessToken },
              }),
            )
          }
          minWidth={150}
          fullWidth
          hoverIcon=""
          variant="yam"
        >
          See Your Box
        </Button>
      </StyledContent>
    </StyledWelcomeToThePackContainer>
  );
};

WelcomeToThePack.propTypes = {
  accessToken: PropTypes.string,
};
